import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { ILogout, logout, setConfigurableUser } from '@src/actions/auth';
import { setMenuTab, setBreadcrumb } from '@src/actions/ui';
import { SidebarTab } from '@src/constants/paths/internal';
import Auth from '@modules/auth/components/lib/auth';
import { ThunkDispatch } from '@src/meta/types/actions';
import { StoreState } from '@src/meta/types/store';
import { SentinelUser } from '@modules/auth/components/types/user';
import { NestedBreadcrumb } from '@src/meta/types/ui';
import NoRBanner from '@modules/billing/widgets/NoRBanner';

import AccountsContainer from '../Account';

type PropsFromState = {
  configurableUser: SentinelUser;
};

type PropsFromDispatch = {
  setMenuTab: (menuTab: SidebarTab) => void;
  logout: () => Promise<ILogout>;
  setConfigurableUser: (user: SentinelUser) => void;
  setBreadcrumb: (breadcrumb: NestedBreadcrumb[]) => void;
};

type Props = PropsFromState & PropsFromDispatch;

const AccountsPage = ({
  configurableUser,
  logout,
  setConfigurableUser,
  setMenuTab,
  setBreadcrumb,
}: Props) => {
  useEffect(() => {
    setMenuTab(SidebarTab.ACCOUNT_SETTINGS);
    setBreadcrumb([]);
  }, [setMenuTab, setBreadcrumb]);
  return (
    <>
      <NoRBanner />
      <AccountsContainer
        configurableUser={configurableUser}
        logout={logout}
        passwordChangeUrlClick={Auth.passwordChangeUrlClick}
        updateUser={setConfigurableUser}
      />
    </>
  );
};

function mapStateToProps(state: StoreState): PropsFromState {
  return {
    configurableUser: state.auth.configurableUser!,
  };
}

const mapDispatchToProps = (dispatch: ThunkDispatch): PropsFromDispatch => {
  return {
    setMenuTab: (tab: SidebarTab) => dispatch(setMenuTab(tab)),
    logout: () => dispatch(logout()),
    setConfigurableUser: (user: SentinelUser) => dispatch(setConfigurableUser(user)),
    setBreadcrumb: (breadcrumb: NestedBreadcrumb[]) => dispatch(setBreadcrumb(breadcrumb)),
  };
};

const enhance = connect(mapStateToProps, mapDispatchToProps);

export default enhance(AccountsPage);
